import { styled } from "@vitality-ds/system";
import BaseLegacyPaperStyles from "./styles/BaseLegacyPaper.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseLegacyPaper = styled("div", BaseLegacyPaperStyles);